import { render, staticRenderFns } from "./BiReportList.vue?vue&type=template&id=6ae7af45&scoped=true"
import script from "./BiReportList.vue?vue&type=script&lang=js"
export * from "./BiReportList.vue?vue&type=script&lang=js"
import style0 from "./BiReportList.vue?vue&type=style&index=0&id=6ae7af45&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae7af45",
  null
  
)

export default component.exports